import React, { ReactNode } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import {
  Dialog,
  Button,
  DialogContent,
  DialogActions,
  DialogTitle
} from "@mui/material";

export interface ConfirmProps {
  title: ReactNode;
  message?: ReactNode;
  cancelLabel?: ReactNode;
  okLabel?: ReactNode;
  onCancel?: () => void;
  onOk?: () => void;
  onModalClose?: () => void;
}

export const Confirm = ({
  open,
  title,
  message,
  cancelLabel,
  okLabel,
  onCancel,
  onOk,
  onModalClose
}: ConfirmProps & { open: boolean }) => {
  return (
    <Dialog open={open} onClose={onModalClose}>
      <DialogTitle>{title}</DialogTitle>
      {message && <DialogContent>{message}</DialogContent>}
      <DialogActions>
        <Button onClick={onCancel} variant="outlined">
          {cancelLabel}
        </Button>
        <Button onClick={onOk}>{okLabel}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default NiceModal.create(
  ({ title, message, cancelLabel, okLabel, onCancel, onOk }: ConfirmProps) => {
    const modal = useModal();

    return (
      <Confirm
        open={modal.visible}
        title={title}
        message={message}
        cancelLabel={cancelLabel || "취소"}
        okLabel={okLabel || "확인"}
        onModalClose={() => modal.remove()}
        onCancel={() => {
          if (onCancel) {
            onCancel();
          } else {
            modal.remove();
          }
        }}
        onOk={() => {
          if (onOk) {
            onOk();
          } else {
            modal.resolve();
            modal.remove();
          }
        }}
      />
    );
  }
);
